import { viewportHeight } from '@utils/dom';
import { useEffect, useRef, useState } from 'react';
import useResponsive, { UseResponsiveProps } from './media-query';

export type UseDisableScrollProps = {
  elementId: string;
  mediaQuery: UseResponsiveProps;
};

export const useDisableScroll = (props: UseDisableScrollProps) => {
  const { elementId, mediaQuery } = props;
  const mediaQueryMatched = useResponsive(mediaQuery);
  useEffect(() => {
    const el = document.getElementById(elementId);
    let overflowValue = '';
    if (el && mediaQueryMatched) {
      overflowValue = el.style.overflow;
      el.style.overflow = 'hidden';
    }

    return () => {
      if (el) {
        el.style.overflow = overflowValue;
      }
    };
  }, [elementId, mediaQueryMatched]);
};

export type UseFullHeightProps = {
  element: HTMLDivElement;
  defaultHeight: number;
  paddingBottom?: number;
};

export const useFullHeight = (props: UseFullHeightProps): number => {
  const { defaultHeight, element, paddingBottom = 0 } = props;
  const ref = useRef<HTMLDivElement>();
  const [height, setHeight] = useState(defaultHeight);

  useEffect(() => {
    if (ref.current) {
      const vh = viewportHeight();
      setHeight(
        vh - (element?.getBoundingClientRect().top ?? 0) - paddingBottom,
      );
    }
  }, [element, paddingBottom]);

  return height;
};
